import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import * as _ from 'lodash';

import { DataService } from '../../../services/data.service';

@Component({
  selector: 'app-gestisci-utente',
  templateUrl: './gestisci-utente.component.html',
  styleUrls: ['./gestisci-utente.component.css']
})
export class GestisciUtenteComponent implements OnInit {
	@Input() data: string = '';
	@Input() writePermission: boolean = false;
	@Output() innerEvents = new EventEmitter();

	ruolo: string = 'cittadino';
	ruoli: any[] = [];
	ruoliSync: Subscription;
	servizi: any[] = [];
	serviziSync: Subscription;
	serviziStructure: any = {};
	serviziStructKeys: any[] = [];
	permessi: any[] = [];
	anagraficheCompatibili: any[] = [];
	anagraficaSelezionata: any = null;
	unlinkAnagrafica: boolean = false;

	selectedPermission: any = null;
	selectedPermissionDetailKeys: any[] = [];

	saveButtonText: string = 'Aggiungi';

	user: any = {
		id: 0,
		username: '',
		livello_id: null,
		codice_fiscale: null
	};

	constructor(private dataService: DataService){
	}

	ngOnInit() {
		this.dataService.getUserServicesByComuneId(this.user.utente_id)
			.subscribe(
				data => {
					this.permessi = data.permessi;
					console.log("GESTISCIUTENTE|PERMESSI:", this.permessi);
					this.setServiziStructure();
				},
				error => console.log(error)
			);
		this.ruoliSync = this.dataService.ruoli$.subscribe(
			ruoli => {
				console.log("GESTISCIUTENTE|RUOLI:", ruoli);
				this.setRuoli(ruoli);
			});
		this.serviziSync = this.dataService.servizi$.subscribe(
			servizi => {
				this.servizi = servizi;
			});
	}

	ngOnChanges(changes: any){
		if (changes.data){
			console.log('CHANGE DATA', changes.data);
			let previousUser = null;
			let currentUser = changes.data.currentValue.user;
			if(changes.data.previousValue){
				previousUser = changes.data.previousValue.user;
			}
			console.log('USER', previousUser, currentUser)
			if (currentUser.id > 0) {
				this.saveButtonText = 'Aggiorna';
				this.user = _.cloneDeep(currentUser);
				this.user.certificazione = Boolean(Number(this.user.certificazione));
				this.anagraficaSelezionata = this.user.id_anagrafica
				if (this.user.livello_id) {
					this.ruolo = this.user.livello_id;
				}
				if (!this.user.id_anagrafica) {
					this.getAnagraficheCompatibili();
				}
				if (!this.user.responsabile_tributo) {
					this.user.responsabile_tributo = false;
				}
				console.log(this.user);
			}
		}
	}

	setRuoli(ruoli:any) {
		this.ruoli = [];
		for (let ruolo of ruoli) {
			let livello = Number(ruolo.livello);
			if ( this.dataService.getUtentiService().getPermissions() == 'superadmin' ) {
				if (livello > 1) {
					this.ruoli.push(ruolo);
				}
			}
			else if ( this.dataService.getUtentiService().getPermissions()[this.dataService.getComuniService().getComuneId()] == 'amministratore' ) {
				if ( livello > 2 ) {
					this.ruoli.push(ruolo);
				}
			}
			else if ( livello > Number(this.dataService.getUtentiService().getPermissions()[this.dataService.getComuniService().getComuneId()].livello) ) {
				this.ruoli.push(ruolo);
			}
		}
	}

	setServiziStructure() {
		for (let servizio of this.servizi) {
			if (!servizio.parent) {
				let parent:any = {
					id: servizio.id,
					nome: servizio.nome,
					value: false,
					dettaglio: JSON.parse(servizio.dettagli),
					children: [],
					reference: null,
					disabled: true,
					toUpdate: false
				}
				// set permissions
				if (this.dataService.getUtentiService().getPermissions() == 'superadmin' || this.dataService.getUtentiService().getPermissions()[this.dataService.getComuniService().getComuneId()] == 'amministratore') {
					parent.disabled = false;
				}
				else if (this.dataService.getUtentiService().getPermissions()[this.dataService.getComuniService().getComuneId()][servizio.nome]) {
					parent.disabled = false;
				}
				// set value
				if (this.user.livello_id == '1' || this.user.livello_id == '2') {
					parent.value = true;
					parent.disabled = true;
				}
				else {
					for (let permesso of this.permessi) {
						if (permesso.servizio_id == servizio.id) {
							parent.value = true;
							parent.reference = permesso.utenti_permessi_id;
							parent.dettaglio = JSON.parse(permesso.dettaglio);
						}
					}
				}
				this.serviziStructure[servizio.id] = parent;
			}
		}
		for (let servizio of this.servizi) {
			if (servizio.parent) {
				let child:any = {
					id: servizio.id,
					nome: servizio.nome,
					value: false,
					dettaglio: JSON.parse(servizio.dettagli),
					reference: null,
					disabled: true,
					toUpdate: false
				};
				// set permissions
				if (this.dataService.getUtentiService().getPermissions() == 'superadmin' || this.dataService.getUtentiService().getPermissions()[this.dataService.getComuniService().getComuneId()] == 'amministratore') {
					child.disabled = false;
				}
				else if (this.dataService.getUtentiService().getPermissions()[this.dataService.getComuniService().getComuneId()][servizio.nome]) {
					child.disabled = false;
				}
				// set values
				if (this.user.livello_id == '1' || this.user.livello_id == '2') {
					child.value = true;
					child.disabled = true;
				}
				else {
					for (let permesso of this.permessi) {
						if (permesso.servizio_id == servizio.id) {
							child.value = true;
							child.reference = permesso.utenti_permessi_id;
							child.dettaglio = JSON.parse(permesso.dettaglio);
						}
					}
				}
				this.serviziStructure[servizio.parent].children.push(child);
			}
		}
		this.serviziStructKeys = Object.keys(this.serviziStructure);
		console.log('SERVIZI STRUCTURE',this.serviziStructure);
	}

	getAnagraficheCompatibili() {
		this.dataService.getContribuentiService().getAnagraficheByCf(this.dataService.getComuniService().getComuneId(), this.user.codice_fiscale).subscribe(
			data => {
				if (data.success) {
					this.anagraficheCompatibili = data.anagrafiche;
					console.log('ANAGRAFICHE COMPATIBILI', this.anagraficheCompatibili);
				}
				else {
					this.anagraficheCompatibili = [];
				}
			});
	}

	setAnagraficaCompatibile(id) {
		console.log('ANAGRAFICA COMPATIBILE',id);
		this.anagraficaSelezionata = id;
	}

	aggiornaPermessi(parentId,childId) {
		if (childId) {
			if (!this.serviziStructure[parentId].value) {
				this.serviziStructure[parentId].value = true;
			}
		}
		else {
			for (let child of this.serviziStructure[parentId].children) {
				if (!child.disabled) {
					child.value = this.serviziStructure[parentId].value;
				}
			}
		}
	}

	setParentSubPermissions(id) {
		this.selectedPermission = this.serviziStructure[id];
		this.selectedPermissionDetailKeys = Object.keys(this.selectedPermission.dettaglio);
	}

	setChildSubPermissions(child) {
		this.selectedPermission = child;
		this.selectedPermissionDetailKeys = Object.keys(this.selectedPermission.dettaglio);
	}

	closeSubPermissions() {
		this.selectedPermission = null;
	}

	subPermissionCheck(key,permission) {
		this.selectedPermission.dettaglio[key][permission] = !this.selectedPermission.dettaglio[key][permission];
		if (permission == 'read' && !this.selectedPermission.dettaglio[key][permission]) {
			this.selectedPermission.dettaglio[key]['write'] = false;
		}
		if (permission == 'write' && this.selectedPermission.dettaglio[key][permission]) {
			this.selectedPermission.dettaglio[key]['read'] = true;
		}
		this.selectedPermission.toUpdate = true;
		console.log(this.selectedPermission);
	}

	checkCertificato() {
		console.log('CERTIFICATO',this.user.certificazione);
		if (!this.user.certificazione) {
			this.user.responsabile_tributo = this.user.certificazione;
		}
	}

	salvaUtente() {
		let localFilters = [];
		let userData: any = {
			codice_fiscale: this.user.codice_fiscale,
			certificazione: this.user.certificazione,
			id_anagrafica: this.anagraficaSelezionata
		};

		if (this.unlinkAnagrafica || !this.user.certificazione) {
			userData.id_anagrafica = null;
		}

		if (this.user.certificazione && !this.user.data_certificazione) {
			userData['data_certificazione'] = Date.now();
		}

		if (this.user.utente_id) {
			localFilters.push({ type: "=", key: "id", value: this.user.utente_id });
			this.dataService.update('utenti', localFilters, userData, false, (error,res) => {
				if(res){
					this.checkRole();
				}
			});
		}
		else {
			localFilters.push({ type: "=", key: "id", value: this.user.id });
			this.dataService.update('utenti', localFilters, userData, false, (error,res) => {
				if(res){
					this.checkRole();
				}
			});
		}
	}

	checkRole() {
		console.log('checkRole');
		let localFilters = [];
		if (this.ruolo == 'cittadino' && this.user.livelli_utenti_id) {
			console.log('checkRole 1');
			localFilters.push({ type: "=", key: "id", value: this.user.livelli_utenti_id });

			this.dataService.delete('livelli_utenti', localFilters, true, (error,res) => {
				console.log('POST DELETE LIVELLI_UTENTI',error,res);
				if (error) {
					//this.dataService.openMessage('MODIFICA UTENTE','si è verificato un problema');
				}
				if(res){
					this.checkSalvaPermessi();
				}
			});
		}
		else if (this.user.livelli_utenti_id) {
			console.log('checkRole 2');
			// aggiorna livello
			let livello: any = {
				utente_id: this.user.utente_id,
				comune_id: this.dataService.getComuniService().getComuneId(),
				livello_id: this.ruolo,
				responsabile_tributo: this.user.responsabile_tributo
			}
			localFilters.push({ type: "=", key: "id", value: this.user.livelli_utenti_id });

			this.dataService.update('livelli_utenti', localFilters, livello, true, (error,res) => {
				if(res){
					this.checkSalvaPermessi();
				}
			});
		}
		else if (!this.user.livelli_utenti_id && this.ruolo != 'cittadino') {
			console.log('checkRole 3');
			// aggiungi livello
			let livello: any = {
				utente_id: this.user.id,
				comune_id: this.dataService.getComuniService().getComuneId(),
				livello_id: this.ruolo,
				responsabile_tributo: this.user.responsabile_tributo
			}
			console.log('livello',livello);
			this.dataService.insert('livelli_utenti', livello, true, (error,res) => {
				console.log('POST INSERT LIVELLI_UTENTI',error,res);
				if (error) {
					this.dataService.openMessage('MODIFICA UTENTE','si è verificato un problema');
				}
				else {
					this.hide();
				}
			});
		}
		else {
			console.log('checkRole 4');
			this.hide();
		}
	}

	checkSalvaPermessi() {
		console.log('checkSalvaPermessi');
		if (this.ruolo != 'cittadino' && this.user.livelli_utenti_id) {
			this.salvaPermessi();
		}
		else {
			this.hide();
		}
	}

	salvaPermessi() {
		console.log('SALVA PERMESSI');
		let localFilters = [];
		for (let id in this.serviziStructure) {
			let parent = this.serviziStructure[id];
			if (!parent.disabled) {
				if (this.ruolo == 'cittadino' && parent.reference) {
					localFilters.push({ type: "=", key: "id", value: parent.reference });

					this.dataService.delete('utenti_permessi', localFilters, false, (error,res) => {
						if (error) {
							//this.dataService.openMessage('MODIFICA PERMESSI','si è verificato un problema');
						}
					});
				}
				else if (parent.value && !parent.reference) {
					console.log('AGGIUNGI:', id);
					let permesso = {
						livello_utente_id: this.user.livelli_utenti_id,
						servizio_id: id,
						dettaglio: JSON.stringify(parent.dettaglio)
					}
					this.dataService.insert('utenti_permessi', permesso, false, (error,newId) => {
						if (error) {
							this.dataService.openMessage('MODIFICA PERMESSI','si è verificato un problema');
						}
					});
				}
				else if (!parent.value && parent.reference) {
					console.log('RIMUOVI:', id);
					localFilters.push({ type: "=", key: "id", value: parent.reference });

					this.dataService.delete('utenti_permessi', localFilters, false, (error,res) => {
						if (error) {
							//this.dataService.openMessage('MODIFICA PERMESSI','si è verificato un problema');
						}
					});
				}
				else if (parent.reference && parent.toUpdate) {
					console.log('AGGIORNA:', id);
					let permesso = {
						livello_utente_id: this.user.livelli_utenti_id,
						servizio_id: id,
						dettaglio: JSON.stringify(parent.dettaglio)
					}
					localFilters.push({ type: "=", key: "id", value: parent.reference });

					this.dataService.update('utenti_permessi', localFilters, permesso, false, (error,res) => {});
				}

				// INIZIO
				for(let child of parent.children) {
					if (!child.disabled) {
						if (this.ruolo == 'cittadino' && child.reference) {
							localFilters.push({ type: "=", key: "id", value: child.reference });

							this.dataService.delete('utenti_permessi', localFilters, false, (error,res) => {
								if (error) {
									//this.dataService.openMessage('MODIFICA PERMESSI','si è verificato un problema');
								}
							});
						}
						else if (child.value && !child.reference) {
							console.log('AGGIUNGI:', id);
							let permesso = {
								livello_utente_id: this.user.livelli_utenti_id,
								servizio_id: child.id,
								dettaglio: JSON.stringify(child.dettaglio)
							}
							this.dataService.insert('utenti_permessi', permesso, false, (error,newId) => {
								if (error) {
									this.dataService.openMessage('MODIFICA PERMESSI','si è verificato un problema');
								}
							});
						}
						else if (!child.value && child.reference) {
							console.log('RIMUOVI:', child.id);
							localFilters.push({ type: "=", key: "id", value: child.reference });

							this.dataService.delete('utenti_permessi', localFilters, false, (error,res) => {
								if (error) {
									//this.dataService.openMessage('MODIFICA PERMESSI','si è verificato un problema');
								}
							});
						}
						else if (child.reference && child.toUpdate) {
							console.log('AGGIORNA:', child.reference);
							let permesso = {
								livello_utente_id: this.user.livelli_utenti_id,
								servizio_id: child.id,
								dettaglio: JSON.stringify(child.dettaglio)
							}
							localFilters.push({ type: "=", key: "id", value: child.reference });

							this.dataService.update('utenti_permessi', localFilters, permesso, false, (error,res) => {});
						}
					}
				}
				// FINE
			}
		}
		this.hide();
	}

	resetUser() {
		this.user = {
			id: 0,
			username: '',
			livello_id: null,
			codice_fiscale: null
		};
	}

	hide(){
		console.log('GESTIONE UTENTI HIDE');
		this.dataService.getComuniService().getCittadini();
		this.dataService.getComuniService().getOperatori(this.dataService.getUtentiService().getUserByComune());
		this.resetUser();
		let event: any = {
			hide: true,
		}
		this.innerEvents.emit(event);
	}

	ngOnDestroy() {
		this.ruoliSync.unsubscribe();
	}

}
